// extracted by mini-css-extract-plugin
export default {"page":"bY-z","cartModal":"cY-z","checkout":"dY-z","placeholder":"eY-z","account":"fY-z"};